<div class="formstep_detail"><smart-table :options="options" label-tag="h4" label-class="h5"></smart-table></div>